export default class StationWithWatershedDto {
    constructor(object) {
        this.id = object.code
        this.type = object.typeStation
    }
}